/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdAttachmentsClassStudentsQueryResponse,
  GetApiV1PersonIdAttachmentsClassStudentsPathParams,
  GetApiV1PersonIdAttachmentsClassStudentsQueryParams,
  GetApiV1PersonIdAttachmentsClassStudents401,
  GetApiV1PersonIdAttachmentsClassStudents404,
  GetApiV1PersonIdAttachmentsClassStudents500,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachmentsClassStudents.ts";

function getGetApiV1PersonIdAttachmentsClassStudentsUrl(
  id: GetApiV1PersonIdAttachmentsClassStudentsPathParams["id"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/person/${id}/attachments/class-students` as const,
  };
  return res;
}

/**
 * @description Retorna as turmas em que a pessoa está matriculada (CourseRegistration). Pode filtrar por empresa via companyId. **(Requer Authorization para autenticação)**
 * @summary Turmas (ClassStudent) do aluno para o dropdown da aba Documentos (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/attachments/class-students}
 */
export async function getApiV1PersonIdAttachmentsClassStudents(
  id: GetApiV1PersonIdAttachmentsClassStudentsPathParams["id"],
  params?: GetApiV1PersonIdAttachmentsClassStudentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdAttachmentsClassStudentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdAttachmentsClassStudents401
      | GetApiV1PersonIdAttachmentsClassStudents404
      | GetApiV1PersonIdAttachmentsClassStudents500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdAttachmentsClassStudentsUrl(id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
